import ReactMarkdown from 'react-markdown'
import Tex from '@matejmazur/react-katex'
import math from 'remark-math'
import 'katex/dist/katex.min.css' // `react-katex` does not import the CSS for you




import {Prism as SyntaxHighlighter} from 'react-syntax-highlighter'
import {atomDark} from 'react-syntax-highlighter/dist/esm/styles/prism'

function MarkdownRender(props) {
    
      const renderers = {
        inlineMath: ({value}) => <Tex math={value} />,
        math: ({value}) => <Tex block math={value} />,
        code: ({language, value}) => <SyntaxHighlighter style={atomDark} language={language} children={value} />
      }
      return (
        <ReactMarkdown 
          plugins={[math]}
          renderers={renderers}
          children={props.children}
        />
      );
}

export default MarkdownRender